<template>
  <div class="capture-header">
    <v-navigation-drawer v-model="drawerShown" temporary fixed right>
      <v-toolbar color="#41281b">
      </v-toolbar>      
      <v-divider></v-divider>
      <v-list>
        <v-list-item class="show-sm-and-down" v-on:click="services()">
          <v-list-item-action>
            <v-icon>worker</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="margin-right: 44px;">Services</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="show-sm-and-down" v-on:click="clients()">
          <v-list-item-action>
            <v-icon>person</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Clients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="show-sm-and-down" v-on:click="contactus()">
          <v-list-item-action>
            <v-icon>comment</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Contact</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="show-sm-and-down"></v-divider>

        <v-list-item v-if="!$store.state.isUserLoggedIn" v-on:click="signin()">
          <v-list-item-action>
            <v-icon>person</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Sign in</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div v-if="$store.state.isUserLoggedIn">
          <v-list-item v-on:click="profile()">
            <v-list-item-action>
              <v-icon>person</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{$store.state.user.first_name}}'s profile</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-on:click="dashboard()">
            <v-list-item-action>
              <v-icon>folder</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{$store.state.user.first_name}}'s dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item v-on:click="signout()">
            <v-list-item-action>
              <v-icon>arrow_back</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sign out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="#41281b">
      <v-toolbar-title>
        <v-row class="ts-header">
          <router-link to="/">
            <v-row>
              <Logo class="navlogo"/>
              <div class="header-text ts-logo">
                <span>Think<b>Spatial</b></span>
              </div>            
            </v-row>
          </router-link>         
        </v-row>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon 
        dark 
        class="hidden-md-and-up" 
        v-on:click="drawerShown = !drawerShown">
      </v-app-bar-nav-icon>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-divider vertical></v-divider>
        <v-btn text v-on:click="services()">Services</v-btn>
        <v-btn text v-on:click="clients()">Clients &amp; projects</v-btn>
        <v-btn text v-on:click="contactus()">Contact</v-btn>
        <v-btn v-if="!this.$store.state.isUserLoggedIn" text v-on:click="signin()">
          <v-icon>account_circle</v-icon>
        </v-btn>
        <v-menu offset-y open-on-hover fixed z-index="100001" v-if="this.$store.state.isUserLoggedIn">
          <template v-slot:activator="{ on }">
            <v-btn v-if="$store.state.isUserLoggedIn" text v-on="on">
              <v-avatar v-if="$store.state.user.profile_url" :tile="false" :size="32" color="grey lighten-4" class="mr-2">
                <img :src=$store.state.user.profile_url :alt="$store.state.user.first_name">
              </v-avatar>
              <v-icon v-if="!$store.state.user.profile_url">account_circle</v-icon>
              {{$store.state.user.first_name.charAt(0)}}{{$store.state.user.last_name.charAt(0)}} 
              <v-icon>arrow_drop_down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item class="pointer" v-on:click="profile()">
              <v-list-item-title>{{this.$store.state.user.first_name}}'s profile</v-list-item-title>
            </v-list-item>
            <v-list-item class="pointer" v-on:click="dashboard()">
              <v-list-item-title>{{this.$store.state.user.first_name}}'s dashboard</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item class="pointer" v-on:click="signout()">
              <v-list-item-title>Sign out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import Logo from 'assets/svg/ts-logo-only.svg';

export default {
  components: {
    Logo
  },
  data() {
    return {
      drawerShown: false,
      menuShown: true,
      contact: {
        duration: 1000,
        offset: 50,
        easing: 'easeInOutCubic',
      }
    };
  },
  methods: {
    /**
     * Method relocate to Services section of front page
     */
    services: function() {
      if(this.$route.path === '/') {
        this.$vuetify.goTo('#services');
      } else {
        this.$router.push({name: 'default'}).then(()=>{
          this.$vuetify.goTo('#services');
        });
      }      
    },
    clients : function(){
      if(this.$route.path === '/') {
        this.$vuetify.goTo('#clients');
      } else {
        this.$router.push({name: 'default'}).then(()=>{
          this.$vuetify.goTo('#clients');
        });
      }  
    },
    contactus : function(){
      if(this.$route.path === '/') {
        this.$vuetify.goTo('#contactus');
      } else {
        this.$router.push({name: 'default'}).then(()=>{
          this.$vuetify.goTo('#contactus');
        });
      }  
    },
    dashboard: function() {
      this.$router.push({ name: 'dashboard' });
    },
    signin: function() {
      this.$router.push({ name: 'signin' });
    },
    signout: function() {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      this.$router.push({
        name: 'default'
      })
    },
    profile: function() {
      this.$router.push({
        name: 'profile',
        query: { user: this.$store.state.user.public_id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'assets/landing.scss';

  .capture-header {
    z-index: 100000;
  }

  .navlogo {
    width: 40px;
    height: 40px;
    fill: #fff;
  }

  .ts-header {
    width: 200px;
    margin-left: 10px;
  }
  .header-text{
    color: #fff;
    margin-left: 0.25em;
    font-size: 25px;
    font-family: 'Lato';
    text-transform: lowercase;
  }

  .v-toolbar .v-btn {
    color: #fff;
  }

  // .drawer-toolbar .title {
  //   color: #fff !important;
  // }

  .icon-only-logo {
    width: 24px;
    height: 24px;
    fill: rgba(0,0,0,0.54);
  }

  .small-email {
    height: 24px;
    color: $text-default;
    padding: 0 0 30px 72px;
    font-size: 0.7em;
  }

  .v-btn i:first-child {
    margin-right: 10px;
  }

  .v-btn i:last-child {
    margin-left: 10px;
  }

  .pointer:hover {
    cursor: pointer !important;
    background: rgba(0,0,0,0.04);
  }
  
</style>

